// extracted by mini-css-extract-plugin
export default {"red":"TransactionCell_red__1Ul81","gray":"TransactionCell_gray__eDno6"};